import { LengthSelectorUI } from "./LengthSelectorUI";
import { StandardProps } from "../componentMap";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { getMinLength } from "../../utils/variant/getMinLength";
import { getFabricRollLength } from "../../utils/variant/getFabricRollLength";

export function LengthSelector({ product }: Pick<StandardProps, "product">) {
  const { variant, isSelected } = useVariant(product);

  const activeVariant = ensureIsActiveVariant(variant);
  if (!activeVariant) return null;

  const { availableToOrder } = activeVariant.availability;
  if (!availableToOrder) return null;

  const minLength = getMinLength(activeVariant);
  const fabricRollLength = getFabricRollLength(activeVariant.attributes || []);

  return (
    <LengthSelectorUI
      minLength={minLength}
      fabricRollLength={fabricRollLength}
    />
  );
}
